var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80994 13.8321H14.2497M6.76544 3.0006L10.8544 6.14085M8.08469 1.3461C8.36795 1.01137 8.77061 0.800348 9.20704 0.757909C9.64348 0.71547 10.0793 0.844965 10.4217 1.11885L11.7214 2.1291C11.906 2.23855 12.0668 2.38388 12.1943 2.55649C12.3218 2.72911 12.4134 2.92552 12.4638 3.13414C12.5141 3.34275 12.5221 3.55933 12.4874 3.7711C12.4526 3.98286 12.3758 4.18552 12.2614 4.3671C12.2359 4.4076 5.10869 13.3229 5.10869 13.3229C4.9903 13.4698 4.84074 13.5886 4.67083 13.6707C4.50092 13.7528 4.31489 13.7962 4.12619 13.7976L1.39769 13.8321L0.782692 11.2296C0.696442 10.8629 0.782692 10.4789 1.01969 10.1826L8.08469 1.3461Z",
    stroke: "#1570EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.9e9de5ad4fddf73e58273ae79f487448.svg";
export { ForwardRef as ReactComponent };